module.exports = __webpack_public_path__ + "images/corners/Pier.d9df9621e661a68f1013b5bdcfb8571d.jpg";